"use client";

import {CardBody, CardFooter, CardHeader} from "@heroui/card";
import {Input} from "@heroui/input";
import {Button} from "@heroui/button";
import {EyeIcon, EyeSlashIcon} from "@heroicons/react/24/solid";
import {useState} from "react";
import {useTranslations} from "next-intl";

import {Image} from "@/lib/components/ui/image";
import {Link} from "@/lib/components/ui/link";
import {Card} from "@/lib/components/ui/card";

const Loading = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);

  const t = useTranslations("LoginPage");

  return (
    <div className="w-full sm:max-w-[500px] px-4 py-8">
      <Card className="sm:p-6 lg:p-8">
        <CardHeader className="mb-6">
          <Image
            alt="OVision logo"
            className="sm:mx-auto h-10 w-[162px]"
            height={40}
            loading="eager"
            src="/images/logo.svg"
            width={162}
          />
        </CardHeader>
        <CardBody>
          <div className="space-y-4">
            <Input
              disabled
              isRequired
              aria-label={t("username.label")}
              id="username"
              label={t("username.label")}
              name="username"
              placeholder={t("username.placeholder")}
              size="lg"
              type="email"
            />

            <Input
              disabled
              fullWidth
              aria-label={t("password.label")}
              endContent={
                <button
                  aria-label="toggle password visibility"
                  className="focus:outline-solid outline-transparent cursor-pointer"
                  type="button"
                  onClick={toggleVisibility}
                >
                  {isVisible ? (
                    <EyeSlashIcon className="size-6 text-default-400 pointer-events-none" />
                  ) : (
                    <EyeIcon className="size-6 text-default-400 pointer-events-none" />
                  )}
                </button>
              }
              id="password"
              label={t("password.label")}
              maxLength={32}
              minLength={8}
              name="password"
              placeholder={t("password.placeholder")}
              size="lg"
              type={isVisible ? "text" : "password"}
            />
            <Button disabled fullWidth color="primary" type="submit">
              {t("submitButton")}
            </Button>
          </div>
        </CardBody>
        <CardFooter>
          <Link href="/forgot-password">{t("forgotPassword")}</Link>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Loading;
